import { Children, useEffect, useRef, useState } from "react";

/**
 * Hàng thẻ quẹt ngang trên điện thoại, dùng chung cho mọi danh sách thẻ ở
 * trang chủ (bốn thẻ việc, bài Playbook nổi bật...).
 *
 * Máy tính: chỉ là một div mang className truyền vào, lưới do CSS của danh
 * sách đó quyết định. Điện thoại (≤ 640px): CSS `.hang-quet` biến nó thành
 * một hàng scroll-snap, thẻ kế tiếp hé ra ở mép phải, kèm chấm vị trí.
 * Quẹt không cần JavaScript; JS chỉ cập nhật chấm và cho bấm chấm để nhảy.
 */
export default function HangQuet({ className = "", children }) {
  const ref = useRef(null);
  const [dang, setDang] = useState(0);
  const so = Children.count(children);

  // Thứ tự nhìn thấy (CSS `order` có thể đổi), không phải thứ tự DOM.
  const theoViTri = () => [...ref.current.children].sort((a, b) => a.offsetLeft - b.offsetLeft);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let khung = 0;
    const doi = () => {
      cancelAnimationFrame(khung);
      khung = requestAnimationFrame(() => {
        const ds = theoViTri();
        const goc = el.scrollLeft + parseFloat(getComputedStyle(el).scrollPaddingLeft || 0) + el.offsetLeft;
        let gan = 0;
        ds.forEach((c, i) => { if (Math.abs(c.offsetLeft - goc) < Math.abs(ds[gan].offsetLeft - goc)) gan = i; });
        // Cuộn hết cỡ: thẻ cuối đang hiện đủ dù không chạm mép trái.
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) gan = ds.length - 1;
        setDang(gan);
      });
    };
    el.addEventListener("scroll", doi, { passive: true });
    return () => { el.removeEventListener("scroll", doi); cancelAnimationFrame(khung); };
  }, []);

  const toi = (i) => {
    const el = ref.current;
    const the = el && theoViTri()[i];
    if (the) el.scrollTo({ left: the.offsetLeft - el.offsetLeft - parseFloat(getComputedStyle(el).scrollPaddingLeft || 0), behavior: "smooth" });
  };

  return (
    <>
      <div className={`hang-quet ${className}`} ref={ref}>{children}</div>
      {so > 1 && <div className="hang-quet-cham" aria-hidden="true">
        {Array.from({ length: so }, (_, i) => (
          <button type="button" tabIndex={-1} key={i} className={i === dang ? "dang" : ""} onClick={() => toi(i)} />
        ))}
        <span>Quẹt để xem thêm</span>
      </div>}
    </>
  );
}
